<template>
  <div>
    <el-container>
      <!-- el-header默认高度60px -->
      <el-header >
        <Header ></Header>
      </el-header>
      <el-container>
        <!-- el-aside 默认宽度 200px -->
        <el-aside>
          <Menu></Menu>
        </el-aside>
        <el-main>
          <transition
            name="fade"
            mode="out-in"
          >
           <router-view />
            <!-- <keep-alive exclude="Repository,ServiceGoodsAdd,ContractGoodsAdd,RegulationsAdd,WorkTicketsAdd,GuideAdd">
             
            </keep-alive> -->
          </transition>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Menu from '@/components/menu.vue'
export default {
  components: {
    Header,
    Menu
  },
  methods: {

  },
  mounted () {
    console.log(this.$router);
  }
};
</script>
<style scoped lang="scss">
::v-deep.el-main {
  background: #f5f5f5;
  height: calc(100vh - 60px);
  padding: 10px;
}
::v-deep .el-aside {
  // 这里如果修改了width,要同时修改header里面的logo宽度
  width: 230px !important;
  height: calc(100vh - 60px);
  background: #ffffff;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.001s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
